import { NotificationModel } from 'src/app/notification/models/notification';


export declare type DocumentModel = {
    id?: string;
    url?: string;
    label?: string | undefined;
}

export declare type ValueObjectOfVariantOption = {
}

export declare type VariantOption = ValueObjectOfVariantOption & {
    id?: string;
    name?: string;
    description?: string | undefined;
    imageUrl?: string | undefined;
    sortOrder?: number;
    groupId?: string;
    translatedSpecifications?: string[];
    specifications?: Specification | undefined;
}

export declare type Specification = {
    name?: string;
    group?: SpecificationGroup | undefined;
    value?: any | undefined;
    unit?: string | undefined;
    useAsFacet?: boolean;
    sortOrder?: number;
    type?: string;
}

export declare type CustomizerAccessoryLayout = {
    imgUrl: string;
    name: string;
    variation: (VariantOption & VariantType)[];
    price: Money;
    id: string;
    isSelcted?: boolean;
}
export declare type CustomizerMainLayout = {
    productId: string;
    variation: string;
    variatants: {
        type: string;
        option: string;
    }[];
}[];
export declare type SpecificationGroup = {
    id?: string;
    name?: string;
    sortOrder?: number;
}

export declare type VariantType = {
    type?: string;
    title?: string;
    longTitle?: string | undefined;
    description?: string | undefined;
    view?: string | undefined;
    index?: number;
}

export declare type VariantGroup = {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    sortOrder?: number;
}

export declare type AddonModel = {
    brand?: string | undefined;
    googleProductCategory?: string | undefined;
    options?: { [key: string]: VariantOption; } | undefined;
    productType?: string | undefined;
    variantPrices?: { [key: string]: string; } | undefined;
    variantTypes?: VariantType[] | undefined;
    images?: string[] | undefined;
    priceDictionary?: { [key: string]: Price; } | undefined;
    price?: Price | undefined;
    id?: string | undefined;
}

export declare type Indicator = {
    text?: string;
    textColor?: string | undefined;
    backgroundColor?: string | undefined;
    display?: string | undefined;
}

export declare type ProductModel = {
    documents?: DocumentModel[] | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    relatedProductIds?: string[][] | undefined;
    price?: Price | undefined;
    primaryTag?: string | undefined;
    productType?: string;
    seoTitle?: string;
    estimatedShippingPrice?: Price | undefined;
    seoDescription?: string;
    id?: string;
    name?: string;
    url?: string | undefined;
    addons?: AddonModel[];
    designer?: string;
    googleProductCategory?: string | undefined;
    variantGroups?: { [key: string]: VariantGroup; };
    variantTypes?: VariantType[];
    variantPrices?: { [key: string]: string; } | undefined;
    options?: { [key: string]: VariantOption; } | undefined;
    specifications?: Specification[];
    brand?: string;
    brandUrlSegment?: string;
    images?: string[];
    indicators?: Indicator[];
    saleUnitSize?: number;
    campaignFrom?: Date | undefined;
    campaignTo?: Date | undefined;
    priceDictionary?: { [key: string]: Price; };
    categoryGroupCustomizerSelectionTitle?: string | undefined;
}

export declare type ValueObjectOfPrice = {
}

export declare type Price = ValueObjectOfPrice & {
    id?: string;
    listPrice?: Money;
    salesPrice?: Money;
    vatAmount?: Money;
    vatRate?: number;
    discounts?: Discount[];
    quantityPrices?: { [key: string]: QuantityPrice; } | undefined;
}

export declare type ValueObjectOfMoney = {
}

export declare type Money = ValueObjectOfMoney & {
    amount?: number;
    currency?: string;
}

export declare type Discount = {
    currency?: string | undefined;
    type?: string;
    amount?: number;
    reference?: string;
}

export declare type ValueObjectOfQuantityPrice = {
}

export declare type QuantityPrice = ValueObjectOfQuantityPrice & {
    totalSalesPrice?: Money;
    id?: string;
    listPrice?: Money;
    salesPrice?: Money;
    vatAmount?: Money;
    vatRate?: number;
    discounts?: Discount[];
    quantityPriceDescriptor?: string | undefined;
}
export declare type CustomizerVariant = string;
export declare type CustomizerVariation = string;
export declare type CustomizerPriceKey = string;
export declare type CustomizerType = number;
export declare type CustomizerViewVariation = {
    key: CustomizerVariant,
    price: {
        low: string,
        high: string,
    },
};
export declare type CustomizerSelected = {
    main: CustomizerVariation;
    addons: CustomizerVariation[];
}
export declare type CustomizerViewGroup = {
    variants: CustomizerViewVariation[],
    group: string
}
export declare type CustomizerView = {
    selected: CustomizerVariation;
    type: CustomizerType;
    variantGroups: CustomizerViewGroup[];
}
export declare type CustomizerModel = {
    total?: Price | undefined;
    product?: ProductModel;
    content?: any | undefined;
}
export declare type CustomizerRequest = {
    catalog?: string;
    baseUrl?: string;
    id: string;
    customizer?: CustomizerModel;
    path?: string[]; // [product id, ...variant id]
    select?: string;
    selected?: CustomizerSelected;
}
export type CustomizerDialogHead = {
    typeTitle: string,
    productName: string,
    currentStep: number,
    totalSteps: number,
    overview: any
}
export declare type CustomizerRequestBody = Pick<CustomizerRequest, "catalog" | "baseUrl" | "customizer"> & { selected?: CustomizerSelected }
export declare type CustomizerResponse = {
    id: string;
    customizer: CustomizerModel;
    selected: CustomizerSelected;
    inView?: CustomizerView;
    error?: NotificationModel;
    request?: CustomizerRequest;
    mainLayout?: CustomizerMainLayout;
    accessoryLayout?: CustomizerAccessoryLayout;
    dialogFilters?: CustomizerDialogFilter[];
    dialogView?: CustomizerDialogView;
    dialogHead?: CustomizerDialogHead;
}
export declare type CustomizerDialogFacet = {
    id: string;
    value: string;
    depth: number;
    title: string;
}
export declare type CustomizerDialogFilter = {
    title: string;
    facets: CustomizerDialogFacet[];
}
export declare type VariantOptionPrice = VariantOption & Price;
export declare type CustomizerDialogVariant = {
    variation: string;
    high: VariantOptionPrice;
    low: VariantOptionPrice;
    selected: boolean
}
export declare type CustomizerDialogGroup = {
    id: string;
    hidden: boolean;
    name: string;
    description: string;
    translatedSpecifications: string[];
    variants: CustomizerDialogVariant[];
}
export declare type CustomizerDialogView = {
    mode: string;
    productId: string;
    productType: string;
    groups: CustomizerDialogGroup[];
    previous: string[] | null;
    next: string[] | null;
    atStart: boolean;
    atEnd: boolean;
}
async function retryWeb<T>(
    fn: () => Promise<T>,
    maxRetries: number = 3,
    timeoutMs: number = 3000
): Promise<T> {
    let retries = 0;
    let response = null;
    let error = null

    while ((response == null || (response != null && 'status' in response && response?.status !== 200)) && retries < maxRetries) {
        try {
            response = await fn();
        } catch (e) {
            error = e
        }

        if ((response == null || (response != null && 'status' in response && response?.status !== 200)))
            await new Promise(_resolve => setTimeout(_resolve, timeoutMs));
        retries++;
    }
    if (response == null && error != null)
        throw new Error(error);

    return response;
}

export namespace Customizer {
    export const ViewType = Object.freeze({
        Combi: 'Combi1And2'
    })

    export async function reHydrate(request: CustomizerRequest | CustomizerRequestBody): Promise<CustomizerModel> {
        let url = new URL(`api/${("" + request.catalog)}/product/get-product-customizer`, request.baseUrl).toString();
        let requestInit: RequestInit = {
            method: "POST", headers: { "Accept": "application/json", "Content-Type": "application/json", },
            body: JSON.stringify(request.customizer == null ? mapRequestBodyInit(request as CustomizerRequestBody) : mapRequestBody(request as CustomizerRequest))
        };
        let response = await retryWeb(() => fetch(url, requestInit));
        if (response.status != 200) {
            throw new Error(await response.text());
        }
        let data = await response.json();
        return data as CustomizerModel;
    }

    export function mapRequestBodyInit(request: CustomizerRequestBody) {
        return {
            product: request.selected.main,
            selectedAddons: request.selected.addons,
        };
    }

    export function mapSelected(request: CustomizerRequest | CustomizerResponse): CustomizerSelected {
        if (request?.customizer?.product)
            return {
                main: request.customizer.product.id,
                addons: request.customizer.product.addons.map(addon => addon.id)
            }
        if (request?.selected)
            return request?.selected
        return {
            main: '',
            addons: []
        }
    }

    export function mapView(request: CustomizerRequest, response: CustomizerResponse): CustomizerView {
        // console.debug('View', request, response);
        let [productId, ...variantIds] = request.path;
        let type = variantIds?.length ?? 0;
        let product = getProduct(response, productId);
        // console.debug('View - product', product);
        let selected = product.id;
        let variantGroups = mapVariants(response, product, variantIds, type);
        // console.debug('View - variantGroups', variantGroups, selected, type);
        return { selected, type, variantGroups };
    }

    export function needsHydration(request: CustomizerRequest, response: CustomizerResponse) {
        if (response.customizer == null)
            return true;
        if (request.select == null)
            return false;
        return request.select != response.customizer.product.id &&
            !response.customizer.product.addons.some(addon => addon.id == request.select);
    }

    export function getProduct(response: CustomizerResponse, productId: string): ProductModel {
        productId = productId.split(',')[0];
        if (response.customizer.product.id.startsWith(productId))
            return response.customizer.product;
        return response.customizer.product.addons.find(addon => addon.id.startsWith(productId));
    }

    export function mapDialogFilters(response: CustomizerResponse): CustomizerDialogFilter[] {
        if (response == null || response.inView == null)
            return null;
        let product = getProduct(response, response.inView.selected);
        let isCombi = product.variantTypes[response.inView.type].view == ViewType.Combi;
        if (!isCombi)
            return null;
        let _filters = {
            0: {
                type: product.variantTypes[response.inView.type],
                facets: []
            }, 1: {
                type: product.variantTypes[response.inView.type + 1],
                facets: []
            }
        };

        response
            .inView
            .variantGroups
            .forEach(group => {
                _filters[0].facets.push({
                    id: group.group,
                    value: group.group,
                    depth: 0,
                    title: product.options[group.group].name
                })
                group.variants.forEach(v => {
                    _filters[1].facets.push({
                        id: v.key,
                        value: v.key,
                        depth: 1,
                        title: product.options[v.key].name
                    })
                })
            })
        _filters[0].facets = _filters[0]
            .facets
            .filter((value, index, array) => array
                .findIndex(av => av.id == value.id) === index
            )
        _filters[1].facets = _filters[1]
            .facets
            .filter((value, index, array) => array
                .findIndex(av => av.id == value.id) === index
            )
        return Object.values(_filters).map(filter => ({
            title: filter.type.title,
            facets: Object.values(filter.facets)
        })) as CustomizerDialogFilter[]
    }

    export function mapDialogView(response: CustomizerResponse): CustomizerDialogView {
        if (response == null || response.inView == null)
            return null;
        let product = getProduct(response, response.inView.selected);
        let isCombi = product.variantTypes[response.inView.type].view == ViewType.Combi;
        let atEnd: boolean = getAtEnd(response, product);
        let atStart: boolean = getAtStart(response, product);
        let next: string[] = getNext(response, product, atEnd);
        let previous: string[] = getPrevious(response, product, atStart);
        let productId: string = product.id.split(',')[0];

        let groups = response.inView.variantGroups.map(group => {
            if (isCombi) {
                let __group = product.options[group.group]
                return {
                    id: group.group,
                    name: __group?.name,
                    hidden: false,
                    description: __group?.description,
                    translatedSpecifications: __group?.translatedSpecifications.filter((_, i) => i == 0),
                    variants: group.variants.map(variant => ({
                        variation: variant.key,
                        ...product.options[group.group],
                        ...product.options[variant.key],
                        selected: [variant.price.high, variant.price.low].includes(response.inView.selected.split(',')[1]),
                        high: Object.assign({ variation: variant.price.high }, product.priceDictionary[product.variantPrices[variant.price.high]]) as VariantOptionPrice,
                        low: Object.assign({ variation: variant.price.low }, product.priceDictionary[product.variantPrices[variant.price.low]]) as VariantOptionPrice,
                    } as CustomizerDialogVariant))
                } as CustomizerDialogGroup
            }
            let __group = product.variantGroups[group.group];
            return {
                id: group.group,
                name: __group?.title,
                hidden: false,
                description: __group?.description,
                translatedSpecifications: [],
                variants: group.variants.map(variant => ({
                    variation: variant.key,
                    ...product.options[variant.key],
                    selected: [variant.price.high, variant.price.low].includes(response.inView.selected.split(',')[1]),
                    high: Object.assign({ variation: variant.price.high }, product.priceDictionary[product.variantPrices[variant.price.high]]) as VariantOptionPrice,
                    low: Object.assign({ variation: variant.price.low }, product.priceDictionary[product.variantPrices[variant.price.low]]) as VariantOptionPrice,
                } as CustomizerDialogVariant))
            } as CustomizerDialogGroup
        })
        let productType = product.id === response.customizer.product.id ? 'group' : 'line';

        return { productId, groups, mode: product.variantTypes[response.inView.type].view, atEnd, atStart, next, previous, productType, }
    }

    function getSelectedVariants(product: ProductModel | AddonModel) {
        let [pid, variation] = product.id.split(',');
        if (!variation)
            return [];
        let variants = variation.split(';');
        return variants.map((variant, type) => Object.assign({}, product.options[variant], product.variantTypes[type]));
    }

    export function mapAccessoryLayout(response: CustomizerResponse): CustomizerAccessoryLayout {
        let variation = [
            response.customizer.product,
            ...response.customizer.product.addons
        ]
            .reduce((acc, curr) => acc.concat(getSelectedVariants(curr)), [])
        return {
            imgUrl: response.customizer.product.images[0],
            name: response.customizer.product.name,
            price: response.customizer.total.salesPrice,
            variation,
            id: response.customizer.product.id
        }
    }

    export function mapMainLayout(response: CustomizerResponse): CustomizerMainLayout {
        if (response == null || response.selected == null)
            return null;
        return [response.selected.main, ...(response.selected?.addons ?? [])].map(variation => {
            let product = getProduct(response, variation);
            let [productId, variationStr] = variation.split(',');
            let variationParts = variationStr.split(';');
            let variatants = variationParts
            .map((vid, vi) => ({ type: product.variantTypes[vi].title, option: product.options[vid].name, sortOrder:(product.variantTypes[vi].index ?? Number.MAX_SAFE_INTEGER) }))
            .sort((vidA, vidB) => vidA.sortOrder - vidB.sortOrder)
            return {
                productId,
                variation,
                variatants
            }
        })
    }

    export function mapDialogHead(response: CustomizerResponse): CustomizerDialogHead {
        if (response == null)
            return null;
        let product = getProduct(response, response.inView.selected);
        let products = [response.customizer.product, ...response.customizer.product?.addons];
        let totalSteps = products.map(t => t.variantTypes.length - (t.variantTypes.some(vt => vt.view == ViewType.Combi) ? 1 : 0)).reduce((acc, curr) => acc += curr, 0)
        let currentStep = response.inView.type - prevStepsHasCombi(response.inView.type, product) + getPrevProductsSteps(product, products);
        let productName = response.customizer.product.name;
        let overview = mapDialogHeadSelectedVariants(response);
        let typeTitle = product.variantTypes[response.inView.type].title;
        return { productName, currentStep, totalSteps, overview, typeTitle };
    }

    function mapRequestBody(request: CustomizerRequest): { product: string, selectedAddons: string[] } {
        if (request == null || request.customizer == null)
            return;
        let response = { product: request.customizer.product.id, selectedAddons: request.customizer.product.addons.map(add => add.id) ?? [] };
        let productIdPart = request.select.split(',')[0];
        if (request.customizer.product.id.startsWith(productIdPart)) {
            response.product = request.select;
        } else {
            response.selectedAddons = response.selectedAddons.map(id => id.startsWith(productIdPart) ? request.select : id)
        }
        return response;
    }

    function SimilarityLength(strA: string, strB: string) {
        let strASplitted = strA.split(';');
        let strBSplitted = strB.split(';');
        return strASplitted.reduce((acc, curr, i) => acc += (curr == strBSplitted[i] ? 1 : 0), 0);
    }

    function mapVariants(
        response: CustomizerResponse,
        product: ProductModel | AddonModel,
        selectedVariantIds: string[],
        type: number
    ): CustomizerViewGroup[] {
        let currentSelected = product.id.split(',')[1];
        let groups: {
            [key: string]: {
                group: string,
                variants: { [key: string]: CustomizerViewVariation } | CustomizerViewVariation[]
            }
        } = {};
        let partVariation = selectedVariantIds.filter((_, i) => i < type).join(';')
        let isCombi = product.variantTypes[type].view == ViewType.Combi;

        Object
            .entries(product?.variantPrices ?? {})
            .forEach(([variation, priceKey]) => {
                if (!variation.startsWith(partVariation))
                    return;
                let variantKeys = variation.split(';');
                let variantId = isCombi ? variantKeys[type + 1] : variantKeys[type];
                /// Group get/set ///////
                let groupId = isCombi ? variantKeys[type] : product.options[variantId]?.groupId ?? '';
                if (!(groups[groupId]))
                    groups[groupId] = {
                        group: groupId,
                        variants: {}
                    }
                let group = groups[groupId];
                //////////////////////////////////////////
                if (!(group.variants[variantId])) // variant not set yet
                    group.variants[variantId] = {
                        key: variantId,
                        price: {
                            low: variation,
                            high: variation,
                        }
                    }
                else {
                    let savedVariant = group.variants[variantId];
                    let savedPriceHigh = product.priceDictionary[product.variantPrices[savedVariant.price.high]];
                    let savedPriceLow = product.priceDictionary[product.variantPrices[savedVariant.price.low]];
                    let currentSimilarityLength = SimilarityLength(variation, currentSelected);
                    let currentPrice = product.priceDictionary[product.variantPrices[variation]];
                    if (variation == currentSelected)
                        savedVariant.price.high = variation;
                    else if (savedVariant.price.high != currentSelected) {
                        if (savedPriceHigh.salesPrice.amount < currentPrice.salesPrice.amount)
                            savedVariant.price.high = variation;
                        else if (savedPriceHigh.salesPrice.amount == currentPrice.salesPrice.amount && SimilarityLength(savedVariant.price.high, currentSelected) < currentSimilarityLength)
                            savedVariant.price.high = variation;
                    }
                    if (variation == currentSelected)
                        savedVariant.price.low = variation;
                    else if (savedVariant.price.low != currentSelected) {
                        if (savedPriceLow.salesPrice.amount > currentPrice.salesPrice.amount)
                            savedVariant.price.low = variation;
                        else if (savedPriceLow.salesPrice.amount == currentPrice.salesPrice.amount && SimilarityLength(savedVariant.price.low, currentSelected) < currentSimilarityLength)
                            savedVariant.price.low = variation;
                    }

                }
            });

        return Object
            .values(groups)
            .map((group) => {
                group.variants = Object
                    .values(group.variants)
                    .sort((va, vb) => product.options[va.key].sortOrder - product.options[vb.key].sortOrder)
                return group as CustomizerViewGroup;
            })
            .sort((groupA, groupB) => groupSortOrder(product, groupA.group) - groupSortOrder(product, groupB.group));
    }

    function groupSortOrder(product: ProductModel | AddonModel, group: string) {
        if (product['variantGroups'] == null)
            return Number.MAX_SAFE_INTEGER;
        if (product['variantGroups'][group] == null)
            return Number.MAX_SAFE_INTEGER;
        return product['variantGroups'][group]['sortOrder'];
    }

    function dialogMapFacet(product: ProductModel, group: CustomizerViewGroup, type: number): any {
        let _group = product.variantGroups[group.group] ?? product.options[group.group];
        return {
            id: group,
            value: group,
            depth: type,
            title: (_group as VariantGroup).title ?? (_group as VariantOption).name,
        }
    }

    function getAtEnd(response: CustomizerResponse, product: ProductModel): boolean {
        let offset = product.variantTypes[response.inView.type].view == ViewType.Combi ? 2 : 1;
        // is not an end of current products types
        // // console.debug(product.variantTypes.length, offset, response.inView.type)
        if (product.variantTypes.length - offset > response.inView.type)
            return false;
        // meaning at end now
        ////////////////////////
        let viableAddons = (response.customizer.product?.addons ?? []).filter(addon => Object.values(addon?.variantPrices ?? {}).length > 0)
        // has no viable addons
        if ((viableAddons.length) == 0)
            return true;

        // is at last viable addon
        if (viableAddons[viableAddons.length - 1].id == product.id)
            return true;

        // At end of types for current product but has viable addons
        return false;
    }

    function getAtStart(response: CustomizerResponse, product: ProductModel): boolean {
        return product.id == response.customizer.product.id && response.inView.type == 0;
    }

    function getNext(response: CustomizerResponse, product: ProductModel, atEnd: boolean): string[] {
        if (atEnd)
            return null;
        let offset = product.variantTypes[response.inView.type].view == ViewType.Combi ? 2 : 1;
        // is not an end of current products types
        if (product.variantTypes.length - offset > response.inView.type)
            return splitId(response.inView.selected).filter((_, i) => i < response.inView.type + offset + 1)
        let viableAddons = (response.customizer.product?.addons ?? []).filter(addon => Object.values(addon?.variantPrices ?? {}).length > 0)
        let indexOfNextAddon = viableAddons.findIndex(a => a.id == product.id);
        return [viableAddons[indexOfNextAddon + 1].id.split(',')[0]]
    }

    function getPrevious(response: CustomizerResponse, product: ProductModel, atStart: boolean): string[] {
        if (atStart)
            return null;
        let offset = product.variantTypes[Math.max(response.inView.type - 2, 0)].view == ViewType.Combi ? 2 : 1;
        // within same product
        if (response.inView.type - offset >= 0) {
            return splitId(response.inView.selected).filter((_, i) => i < response.inView.type - offset + 1);
        }
        let viableAddons = (response.customizer.product?.addons ?? []).filter(addon => Object.values(addon?.variantPrices ?? {}).length > 0)
        let goToProduct = viableAddons[0].id == product.id ? response.customizer.product : viableAddons[viableAddons.findIndex(a => a.id == product.id) - 1]
        let isCombi__ = goToProduct.variantTypes[goToProduct.variantTypes.length - 2].view == ViewType.Combi;
        return splitId(goToProduct.id).filter((_, i, a) => isCombi__ ? i < a.length - 2 : true)
    }

    function splitId(selected: string): string[] {
        return selected.split(',').reduce((acc, curr) => acc.concat(curr.split(';')), []);
    }

    function prevStepsHasCombi(type: number, product: ProductModel): number {
        let index = product.variantTypes.findIndex(vt => vt.view == ViewType.Combi);
        return index < type ? 0 : 1
    }

    function getPrevProductsSteps(product: ProductModel | AddonModel, products: AddonModel[]) {
        let i = 0;
        let currentStep = 0;
        let found = false;
        while (!found && i < products.length) {
            found = products[i] == product
            if (!found) {
                currentStep += products[i].variantTypes.length;
                if (products[i].variantTypes.some(vt => vt.view === ViewType.Combi))
                    currentStep -= 1
            }
            i++;
        }
        return currentStep;
    }

    function mapDialogHeadSelectedVariants(response: CustomizerResponse) {
        let options = [];
        // let products = [response.customizer.product,...(response.customizer.product.addons??[])]
        options = options.concat(mapDialogHeadSelectedVariantsVariants(response.customizer.product, response.selected.main))
        response.customizer.product.addons.forEach((addon, i) => {
            options = options.concat(mapDialogHeadSelectedVariantsVariants(addon, response.selected.addons[i]))
        })
        return options;

    }

    function mapDialogHeadSelectedVariantsVariants(product: ProductModel | AddonModel, selected: string) {
        if (!selected.includes(','))
            return [];
        let variants = selected.split(',')[1].split(';')
        return product.variantTypes.map((vt, i) => ({
            title: vt.type.replace(':', ''),
            variant: product.options[variants[i]].name
        }))
    }
}


